import { useContext, useEffect, useRef, useState } from "react";
import {
  Users,
  TrendingUp,
  BarChart3,
  Calendar,
  PhoneCall,
} from "lucide-react";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import Skeleton from "@mui/material/Skeleton";
// import InnerLoader from "../../../component/ui/loader/inner-loader";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../component/table/table-layout";
import { CustomDropdown } from "../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../component/ui/dropdown/CustomDropdownButton";
import { CustomDropdownMenu } from "../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../component/ui/dropdown/CustomDropdownMenuList";
// import WorkForceQuickView from "./popup";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  KPI,
  TitleHeading,
} from "../../../component/ui/layout";
// import { FeildWraper, FormArea } from "../../../component/form/form-layout";
// import Picker from "react-month-picker";
// import "react-month-picker/css/month-picker.css";
import moment from "moment";
import { GlobalContext } from "../../../context/Context";
import { FeildWraper } from "../../../component/form/form-layout";
import StatusChip from "../../../component/ui/chip/status";
import InnerLoader from "../../../component/ui/loader/inner-loader";
import Style from "./style.module.css";
import DataNotFound from "../../../component/ui/loader/data-not-found";
import {
  StatCard,
  StatsCardSkeleton,
} from "../../../component/LeadsDashboardComponents/StatCard";
import {
  Clander,
  Clock,
  TeamAvailability,
} from "../../../component/LeadsDashboardComponents/StatCardIcons";
import { ChartMainCard } from "../../../component/LeadsDashboardComponents/ChartsHeader";

// const MONTHS = [
//   "Jan", "Feb", "Mar", "Apr",
//   "May", "Jun", "Jul", "Aug",
//   "Sep", "Oct", "Nov", "Dec"
// ];

// const FULLMONTHS = [
//   "",
//   "January", "February", "March", "April",
//   "May", "June", "July", "August",
//   "September", "October", "November", "December"
// ];

// --- Main Component ---
export default function TeamDashboard() {
  // let data = "";
  let { state } = useContext(GlobalContext);
  const apiCall = useApiCall();

  const [dashboardData, setDashboardData] = useState({});
  const [isDashboardApiLoaded, setIsDashboardApiLoaded] = useState(false);

  const [selectedMonth, setSelectedMonth] = useState(
    moment(new Date()).format("YYYY-MM"),
  );
  const [defaultMonthOption, setDefaultMonthOption] = useState("");
  const [teams, setTeams] = useState([]);

  const getDashboardData = async () => {
    setIsDashboardApiLoaded(false);
    try {
      const resp = await apiCall({
        method: "get",
        url: `get-team-lead-overview?date_range=${defaultMonthOption || selectedMonth}`,
      });
      setDashboardData(resp);
      setIsDashboardApiLoaded(true);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getTeams = async () => {
    try {
      const res = await apiCall({ method: "get", url: `teams/get-user-teams` });
      console.log("getTeams", res);
    } catch (error) {
      console.log("Error", error);
    }
  };

  const getUsers = async (team) => {
    try {
      const res = await apiCall({
        method: "get",
        url: `teams/get-team-user-by-team-id${team ? `/${team}` : ""}`,
      });
      console.log("getUsers", res);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getTeams();
    getUsers();
  }, []);

  useEffect(() => {
    getDashboardData();
  }, [selectedMonth, defaultMonthOption]);

  // LINE CHART

  const getInitials = (name) => {
    if (!name) return "";

    const parts = name.trim().split(" ").filter(Boolean);

    if (parts.length === 1) {
      return parts[0][0].toUpperCase();
    }

    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const [activeChart, setActiveChart] = useState("Miss Reasons");

  const serviceOptionsBar = {
    chart: {
      type: "column",
    },
    title: { text: null },
    credits: { enabled: false },
    xAxis: {
      type: "category",
      title: { text: null },
    },
    yAxis: {
      min: 0,
      title: "none",
      allowDecimals: false,
    },
    legend: { enabled: false },
    series: [
      {
        name: "Reasons",
        data: Object.entries(dashboardData?.miss_reasons || {}).map(
          ([key, val]) => ({
            name: key
              ?.split("_")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" "),
            y: Number(val || 0),
          }),
        ),
      },
    ],
  };

  const platformOptionsBar = {
    chart: {
      type: "column",
    },
    title: { text: null },
    credits: { enabled: false },
    xAxis: {
      type: "category",
      title: { text: null },
    },
    yAxis: {
      min: 0,
      title: "none",
      allowDecimals: false,
    },
    legend: { enabled: false },
    series: [
      {
        name: "Count",
        data: Object.entries(dashboardData?.platform_managed || {}).map(
          ([key, val]) => ({
            name: key
              ?.split("_")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" "),
            y: Number(val || 0),
          }),
        ),
      },
    ],
  };

  const serviceOptions = {
    chart: {
      type: "pie",
    },
    title: { text: null },
    credits: { enabled: false },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        innerSize: "60%", // 👈 makes it a donut
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.y}",
        },
      },
    },
    legend: { enabled: false },
    series: [
      {
        name: "Count",
        colorByPoint: true,
        data: [
          {
            count: dashboardData?.all_time_posted?.posts_delivered || 0,
            name: "Posts Delivered",
            y: parseFloat(dashboardData?.all_time_posted?.posts_delivered || 0),
          },
          {
            count: dashboardData?.all_time_posted?.posts_missed || 0,
            name: "Posts Missed",
            y: parseFloat(dashboardData?.all_time_posted?.posts_missed || 0),
          },
        ],
      },
    ],
  };

  const contentOptions = {
    chart: {
      type: "pie",
    },
    title: { text: null },
    credits: { enabled: false },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        innerSize: "60%", // 👈 makes it a donut
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.y}",
        },
      },
    },
    legend: { enabled: false },
    series: [
      {
        name: "Count",
        colorByPoint: true,
        data: Object.entries(dashboardData?.content_posted || {})?.map(
          ([key, val]) => ({
            count: val || 0,
            name: key
              ?.split("_")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" "),
            y: parseFloat(val || 0),
          }),
        ),
      },
    ],
  };

  const inputRef = useRef();

  const openMonthPicker = () => {
    if (inputRef.current?.showPicker) {
      inputRef.current.showPicker();
    } else {
      inputRef.current?.focus();
      inputRef.current?.click();
    }
  };

  return (
    <>
      <div className="pt-[20px] h-full overflow-hidden">
        <div className="w-full h-full overflow-hidden flex flex-col gap-[20px]">
          {/* Header */}
          <div className="flex items-center justify-between">
            {/* <TitleHeading>Team Lead Overview</TitleHeading> */}
             <div>
              <h1 className="text-2xl font-bold">Team Lead Overview</h1>
            </div>
            <div className="flex gap-3 flex-shrink-0 w-fit items-center justify-end">
              <FeildWraper className={"!w-fit !flex-[0_0_auto] !pl-0 !py-0"}>
                <div className="relative">
                  <input
                    type="month"
                    ref={inputRef}
                    className="absolute opacity-0 pointer-events-none"
                    max={moment(new Date()).format("YYYY-MM")}
                    value={selectedMonth}
                    onChange={(e) => {
                      setDefaultMonthOption("");
                      setSelectedMonth(e.target.value);
                    }}
                  />

                  <CustomDropdown
                    position="bottom-right"
                    className="myDropdown"
                  >
                    <CustomDropdownButton arrow={false} className="btnClass">
                      <h3 className="!text-[16px] px-5 py-1 capitalize flex items-center gap-1">
                        <Calendar className="!w-4 !h-4" />
                        {defaultMonthOption
                          ? defaultMonthOption?.replaceAll("_", " ")
                          : moment(selectedMonth, "YYYY-MM").format(
                              "MMMM YYYY",
                            )}
                      </h3>
                    </CustomDropdownButton>

                    <CustomDropdownMenu className="w-full">
                      <CustomDropdownMenuList
                        onClick={() => {
                          setDefaultMonthOption("this_month");
                          setSelectedMonth("");
                        }}
                      >
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          This Month
                        </div>
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        onClick={() => {
                          setDefaultMonthOption("last_month");
                          setSelectedMonth("");
                        }}
                      >
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          Last Month
                        </div>
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        onClick={() => {
                          setDefaultMonthOption("this_year");
                          setSelectedMonth("");
                        }}
                      >
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          This Year
                        </div>
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList
                        onClick={() => {
                          setDefaultMonthOption("last_year");
                          setSelectedMonth("");
                        }}
                      >
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          Last Year
                        </div>
                      </CustomDropdownMenuList>

                      <CustomDropdownMenuList onClick={openMonthPicker}>
                        <div
                          className={
                            "d-flex whitespace-normal align-items-center gap-1"
                          }
                        >
                          Custom Month
                        </div>
                      </CustomDropdownMenuList>
                    </CustomDropdownMenu>
                  </CustomDropdown>
                </div>
              </FeildWraper>
              {/* <Tooltip
                                className={Style.bpfl_actionItems}
                                content={"Filter"}
                                position={"left center"}
                            >
                                <div
                                    className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                                        }`}
                                    onClick={() => {
                                        setShowModalFilterTable(true);
                                    }}
                                >
                                    <div className={Style.icon}>
                                        <FilterFunnel01Icon />
                                    </div>
                                </div>
                            </Tooltip> */}
            </div>
          </div>

          {/* KPI Row */}
          <TableCard className={"h-full flex"}>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4">
              {isDashboardApiLoaded ? (
                <>
                  <StatCard
                    icon={Clock}
                    iconBgColor="#BBF7D0"
                    iconColor={"#16A34A"}
                    title="Revenue Closed"
                    value={
                      dashboardData?.team_performance?.revenue_closed
                        ?.team_total
                    }
                  />
                  <StatCard
                    icon={Users}
                    iconColor={"#FF7F50"}
                    iconBgColor="#FFEBE0"
                    title="Leads Assigned"
                    value={
                      dashboardData?.team_performance?.leads_assigned
                        ?.team_total
                    }
                  />
                  <StatCard
                    icon={Clander}
                    iconColor={"#335CFF"}
                    iconBgColor="#DBEAFE"
                    title="Conversions"
                    value={
                      dashboardData?.team_performance?.conversions?.team_total
                    }
                  />
                  <StatCard
                    icon={PhoneCall}
                    iconBgColor="#EDE9FE"
                    iconColor={"#6D28D9"}
                    title="Calls Made"
                    value={
                      dashboardData?.team_performance?.calls_made?.team_total
                    }
                  />

                  {/* <KPI
                    // className={"h-full flex flex-col justify-between"}
                    icon={Users}
                    label={"Revenue Closed"}
                    extraClass={"theme"}
                    value={
                      dashboardData?.team_performance?.revenue_closed
                        ?.team_total
                    }
                  />

                  <KPI
                    icon={Users}
                    label={"Leads Assigned"}
                    value={
                      dashboardData?.team_performance?.leads_assigned
                        ?.team_total
                    }
                  />

                  <KPI
                    icon={Users}
                    label={"Conversions"}
                    value={
                      dashboardData?.team_performance?.conversions?.team_total
                    }
                  />

                  <KPI
                    icon={Users}
                    label={"Calls Made"}
                    value={
                      dashboardData?.team_performance?.calls_made?.team_total
                    }
                  /> */}
                </>
              ) : (
                Array.from({ length: 4 }).map((_, index) => (
                  <StatsCardSkeleton />
                ))
              )}
            </div>

            <div className="flex flex-col gap-6 mt-5">
              {/* className="grid grid-cols-1 md:grid-cols-6 gap-6 mt-5" */}
              <div>
                <div className="pb-4">
                  <TitleHeading>Follow Ups</TitleHeading>
                </div>
                <div className="p-5 h-[400px]  bg-white border border-[#E1E4EA] shadow-card rounded-[10px] overflow-hidden">
                  <TableCard>
                    {isDashboardApiLoaded ? (
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Name</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Type</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Client</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Agent</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Activity Subject</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Activity Type</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Priority</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Due Date</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Overdue Days</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Note</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Status</span>
                              </TableHeaderWrap>
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {dashboardData?.followUps?.length ? (
                            dashboardData?.followUps?.map((eachPlat, i) => (
                              <TableRow key={i}>
                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.name}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.type}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.client}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.agent}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.activity_subject}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.activity_type}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.activity_priority}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.due_date}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.overdue_days}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.activity_note}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>
                                      {eachPlat?.activity_status ? (
                                        // <StatusChip
                                        //   color={
                                        //     eachPlat?.activity_status ==
                                        //     "completed"
                                        //       ? "green"
                                        //       : eachPlat?.activity_status ==
                                        //           "cancelled"
                                        //         ? "red"
                                        //         : eachPlat?.activity_status ==
                                        //             "overdue"
                                        //           ? "yellow"
                                        //           : "blue"
                                        //   }
                                        // >
                                        //   {eachPlat?.activity_status}
                                        // </StatusChip>
                                        <span
                                          className="inline-flex py-[4px] px-[12px] rounded-[6px] text-[10px] font-bold uppercase"
                                          style={
                                            eachPlat?.activity_status?.toLowerCase() ==
                                            "completed"
                                              ? {
                                                  background: "#e8f5e9",
                                                  color: "#388e3c",
                                                }
                                              : eachPlat?.activity_status?.toLowerCase() ==
                                                  "pending"
                                                ? {
                                                    background: "#dbe0f5",
                                                    color: "#335CFF",
                                                  }
                                                : eachPlat?.activity_status?.toLowerCase() ==
                                                    "overdue"
                                                  ? {
                                                      background: "#fff3e0",
                                                      color: "#e65100",
                                                    }
                                                  : {
                                                      background: "#fff3e0",
                                                      color: "#e65100",
                                                    }
                                          }
                                        >
                                          {eachPlat.activity_status}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </span>
                                  </TableHeaderWrap>
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={99}>
                                <DataNotFound
                                  title={"Data"}
                                  className={"text-center"}
                                />
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    ) : (
                      <div className="flex justify-center items-center h-full">
                        <InnerLoader />
                      </div>
                    )}
                  </TableCard>
                </div>
              </div>
              {/* <ChartMainCard
                Icon={<TeamAvailability />}
                iconColor={"bg-theme-green-light text-theme-green"}
                heading="Follow Ups"
              >
                {isDashboardApiLoaded ? (
                  <div className="max-h-[430px] min-h-[430px] overflow-auto">
                    {dashboardData?.followUps?.length > 0 ? (
                      <table className="min-w-full">
                        <thead className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                              Name
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                              Type
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                             Client
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                             Agent
                            </th>
                            <th className="px-2 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                             Activity Subject
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                             Activity Type
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                             Priority
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                             Due Date
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                             Overdue Days
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                             Note
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                              Status
                            </th>
                          </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-200">
                          {dashboardData?.followUps?.map((eachPlat, i) => (
                            <tr key={i} className="hover:bg-gray-50">
                              <td className="px-6 py-4">
                                <h6 className="font-semibold text-sm">
                                  {eachPlat?.name?.trim()
                                    ? eachPlat.name
                                    : "-"}
                                </h6>
                              </td>
                              <td className="px-6 py-4">
                                <h6 className="font-medium text-sm">
                                  {eachPlat?.type ?? "-"}
                                </h6>
                              </td>
                              <td className="px-6 py-4">
                                {eachPlat?.client ?? "-"}
                              </td>
                              <td className="px-6 py-4">
                                {eachPlat?.agent ?? "-"}
                              </td>
                              <td className="px-6 py-4">
                                {eachPlat?.activity_subject ?? "-"}
                              </td>
                              <td className="px-6 py-4">
                                {eachPlat?.activity_type ?? "-"}
                              </td>
                              <td className="px-6 py-4">
                                {eachPlat?.activity_priority ?? "-"}
                              </td>
                              <td className="px-6 py-4">
                                {eachPlat?.due_date ?? "-"}
                              </td>
                              <td className="px-6 py-4">
                                {eachPlat?.overdue_days ?? "-"}
                              </td>
                              <td className="px-6 py-4">
                                {eachPlat?.activity_note ?? "-"}
                              </td>
                              <td className="px-6 py-4">
                                <span>
                                  {eachPlat?.activity_status ? (
                                    <span
                                      className="inline-flex py-[4px] px-[12px] rounded-[6px] text-[10px] font-bold uppercase"
                                      style={
                                        eachPlat?.activity_status?.toLowerCase() ==
                                        "completed"
                                          ? {
                                              background: "#e8f5e9",
                                              color: "#388e3c",
                                            }
                                          : eachPlat?.activity_status?.toLowerCase() ==
                                              "pending"
                                            ? {
                                                background: "#dbe0f5",
                                                color: "#335CFF",
                                              }
                                            : eachPlat?.activity_status?.toLowerCase() ==
                                                "overdue"
                                              ? {
                                                  background: "#fff3e0",
                                                  color: "#e65100",
                                                }
                                              : {
                                                  background: "#fff3e0",
                                                  color: "#e65100",
                                                }
                                      }
                                    >
                                      {eachPlat.activity_status}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <DataNotFound title={"Data"} />
                    )}
                  </div>
                ) : (
                  <InnerLoader />
                )}
              </ChartMainCard> */}

              <div>
                <div className="pb-4">
                  <TitleHeading>Team Stats</TitleHeading>
                </div>
                <div className="p-5 h-[400px]  bg-white border border-[#E1E4EA] shadow-card rounded-[10px] overflow-hidden">
                  <TableCard>
                    {isDashboardApiLoaded ? (
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Agent Name</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Leads</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Leads Contacted</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Revenue</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Won Deals</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Lost Deals</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Conversion Percent</span>
                              </TableHeaderWrap>
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {dashboardData?.teamStats?.length ? (
                            dashboardData?.teamStats?.map((eachPlat, i) => (
                              <TableRow key={i}>
                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.agent_name}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.leads}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.leads_contacted}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.revenue}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.won_deals}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.lost_deals}</span>
                                  </TableHeaderWrap>
                                </TableCell>
                                <TableCell>
                                  <TableHeaderWrap>
                                    <span>{eachPlat?.conversion_percent}</span>
                                  </TableHeaderWrap>
                                </TableCell>

                                {/* <TableCell>
                                                            <TableHeaderWrap>
                                                                <span>{eachPlat?.avg_engagement}</span>
                                                            </TableHeaderWrap>
                                                        </TableCell>

                                                        <TableCell>
                                                            <TableHeaderWrap>
                                                                <span>{eachPlat?.activity_status ? <StatusChip color={eachPlat?.status == "Active" ? "green" : "red"}>{eachPlat?.status}</StatusChip> : ""}</span>
                                                            </TableHeaderWrap>
                                                        </TableCell> */}
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={99}>
                                <DataNotFound
                                  title={"Data"}
                                  className={"text-center"}
                                />
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    ) : (
                      <InnerLoader />
                    )}
                  </TableCard>
                </div>
              </div>
            </div>
          </TableCard>
        </div>
      </div>
    </>
  );
}
